// For full API documentation, including code examples, visit https://wix.to/94BuAAs
var subscription=false
$w.onReady(function () {

});

export function textnonpaid_mouseIn(event) {

	
	//Add your code for this event here: 
}

export function switch1_click(event) {
	console.log(subscription)
	subscription = !subscription

	//Add your code for this event here: 
}

export function vectorImage22_mouseIn(event) {
	//$w('#vectorImage36').show()
	//Add your code for this event here: 
}

export function vectorImage23_mouseIn(event) {

	//Add your code for this event here: 
}

export function vectorImage36_mouseOut(event) {
	//$w('#vectorImage36').hide()
	//Add your code for this event here: 
}

export function vectorImage36_mouseIn(event) {

	//Add your code for this event here: 
}

export function vectorImage36_mouseOut_1(event) {

	//Add your code for this event here: 
}

export function vectorImage92_mouseIn(event) {
		let slideOptions = {
  "duration":   200,
  //"delay":      000,
  "direction":  "bottom"
};
	$w('#box8').show("slide",slideOptions)
	//Add your code for this event here: 
}

export function vectorImage92_mouseOut(event) {
	$w('#box8').hide()
	//Add your code for this event here: 
}

export function box6_mouseOut(event) {
	$w('#box6').hide()
	//Add your code for this event here: 
}

export function box7_mouseOut(event) {
	$w('#box7').hide()
	//Add your code for this event here: 
}

export function vectorImage93_mouseIn(event) {
		let slideOptions = {
  "duration":   200,
  //"delay":      000,
  "direction":  "bottom"
};
	$w('#box7').show("slide",slideOptions)
	//Add your code for this event here: 
}

export function vectorImage93_mouseOut(event) {
	$w('#box7').hide()
	//Add your code for this event here: 
}

